export class SchoolBestuur {
  constructor(public schoolbestuur: string, public schoolbestuurNaam: string ) { }
}